module.exports = __webpack_public_path__ + "media/images/navbar-logo-b113984b5f839830a1fd089cc00e133f.png";